import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { ForwardPage } from "../ForwardPage/ForwardPage";
import { PreviousPage } from "../PreviousPage/PreviousPage";
import { SubmitButton } from "../SubmitButton/SubmitButton";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

export const Paginator = observer((props) => {
  const { current, contentLayout, settings, environment, orders, setActivePage } = props;
  const { next, back, showIcons } = settings;
  
  const checkMinGroupReg = () => {
    const grpModule = contentLayout?.contentLayoutModules?.filter(clm => clm.pages == current.activePage).find(clm => clm.contentModule.type === "GROUP_REGISTRATION");
    const minCount = grpModule?.contentModule?.settings?.minCount;
    return minCount && minCount > 0 && minCount > orders.length
  }

  const grpRegDisabled = useMemo(() => {
    let disabled = false;
    if (checkMinGroupReg()) disabled = true;
    return disabled;
  }, [orders, current?.activePage])

  if (contentLayout.pages == 1) {
    return (
        <SubmitButton {...props} grpRegDisabled={grpRegDisabled} />
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: current.activePage > 1 ? "space-between" : "flex-end", width: "100%" }}>
      {current.activePage > 1 ? <PreviousPage current={current} setActivePage={setActivePage} text={showIcons ? <ArrowBackIosIcon className="arrow-icon" /> : back[environment.lang]} /> : null}
      {current.activePage == contentLayout.pages ? <SubmitButton {...props} grpRegDisabled={grpRegDisabled} /> : <ForwardPage {...props} grpRegDisabled={grpRegDisabled} setActivePage={setActivePage} text={showIcons ? <ArrowForwardIosIcon className="arrow-icon" /> : next[environment.lang]} />}
    </div>
  );
});
